module.exports = __webpack_public_path__ + "img/safari.974c1a48.png";